import React, { FunctionComponent } from 'react'
import cn from 'classnames'

import { Icon } from '@/icons'

import styles from './ExampleClasses.module.scss'

const words = [
  'услуги салонов красоты',
  'кофе',
  'услуги по размещению в гостинице',
  'одежда',
  'цветы',
]

type ExampleClassesProps = {
  className?: string
}
export const ExampleClasses: FunctionComponent<ExampleClassesProps> = ({
  className,
}) => {
  return (
    <div className={cn(styles.container, className)}>
      <div className={styles.title}>
        <Icon name="stars" className={styles.titleIcon} />
        <span className={styles.titleText}>Например</span>
      </div>
      <div className={styles.listContainer}>
        <div className={styles.list}>
          {words.map((word) => (
            <span key={word} className={styles.item}>
              {word}
            </span>
          ))}
        </div>
        <div className={styles.list}>
          {words.map((word) => (
            <span key={word} className={styles.item}>
              {word}
            </span>
          ))}
        </div>
      </div>
    </div>
  )
}
